import { Directive, HostListener } from "@angular/core";

@Directive({
    selector: "[creditCard]",
    standalone: false
})
export class CreditCardDirective {
  @HostListener("input", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;

    let trimmed = input.value.replace(/\s+/g, "");
    if (trimmed.length > 16) {
      trimmed = trimmed.substring(0, 16);
    }

    let numbers = [];
    for (let i = 0; i < trimmed.length; i++) {
      numbers.push(trimmed.substring(i, 4));
    }

    input.value = numbers.join(" ");
  }
}
